import { Phone } from "lucide-react";
import { SERVICES, COMPANY } from "@/data/site";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-navy-950 py-24 sm:py-32"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-8">
        <div className="max-w-3xl mb-16">
          <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-brand-light mb-4">
            What We Do
          </p>
          <h2 className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            Full-Service
            <br />
            Construction.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-navy-700">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`group relative border-r border-b border-navy-700 p-8 sm:p-10 transition-colors ${
                  s.accent ? "bg-brand hover:bg-brand-dark" : "hover:bg-navy-900"
                }`}
              >
                <Icon
                  className={`w-10 h-10 mb-6 ${
                    s.accent ? "text-navy-950" : "text-brand-light"
                  }`}
                  strokeWidth={1.5}
                />
                <h3
                  className={`font-display font-bold uppercase text-xl tracking-tight mb-3 ${
                    s.accent ? "text-navy-950" : "text-white"
                  }`}
                >
                  {s.title}
                </h3>
                <p
                  className={`text-base leading-relaxed ${
                    s.accent ? "text-navy-900" : "text-zinc-400"
                  }`}
                >
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-6 border border-navy-700 bg-navy-900/50 p-8">
          <p className="text-lg text-zinc-300 flex-1">
            Have a project in mind? Talk to{" "}
            <span className="text-white font-semibold">{COMPANY.owner}</span>{" "}
            about your scope, timeline, and budget.
          </p>
          <a
            href={COMPANY.phoneHref}
            data-testid="services-call-button"
            className="flex items-center justify-center gap-2 bg-brand hover:bg-brand-dark text-navy-950 font-display font-bold uppercase tracking-wide px-8 py-4 transition-colors whitespace-nowrap"
          >
            <Phone className="w-4 h-4" />
            {COMPANY.phone}
          </a>
        </div>
      </div>
    </section>
  );
};
